import cookieJs from 'js-cookie'
import { COOKIE_PREFIX } from '@/utils/enum'
import env from '@/env'

export function getGateWay () {
  const hostName = parent.location.hostname
  if (isFrame && hostName.indexOf('-feature') > -1) {
    return {
      'gateway-swimlane': 'featur'
    }
  }
  return {}
}

export function getHeaderAuth () {
  let result: any = {
    tenantCode: encodeURIComponent(getCookie('tmsbstmscode')),
    'hango-origin': 'lanqiao'
  }
  const hostName = parent.location.hostname
  if (isFrame && hostName.indexOf('lqfast.com') > -1) {
    result = {
      tmsbstoken: encodeURIComponent(getCookie('tmsbstoken')),
      tmsbsuserid: encodeURIComponent(getCookie('tmsbsuserid')),
      tmsbstmscode: getCookie('tmsbstmscode'),
      requesttoken: getCookie('requesttoken'),
      tmsbsloginsite: encodeURIComponent(getCookie('tmsbsloginsite')),
      replacetitleout: encodeURIComponent(getCookie('replacetitleout')),
      replacetitle: encodeURIComponent(getCookie('replacetitle')),
      ...result
    }
  }
  return result
}

export function getToken () {
  return getCookie('tmsbstoken')
}

function urlAddVersion (url: string) {
  if (!url) return url
  if (url.indexOf('?') > -1) {
    let u = url.split('?')[0]
    let p = url.split('?')[1]
    if (p) {
      return u + '?' + p + '&lqv=' + process.env.TMS_VERSION
    } else {
      return u + '?lqv=' + process.env.TMS_VERSION
    }
  } else {
    return url + '?lqv=' + process.env.TMS_VERSION
  }
}

function encodeHtml (str) {
  let s = ''
  if (str.length === 0) return str
  s = str.replace(/&/g, '>')
  s = s.replace(/</g, '<')
  s = s.replace(/>/g, '>')
  s = s.replace(/ /g, ' ')
  s = s.replace(/'/g, "'")
  s = s.replace(/"/g, '"')
  s = s.replace(/\n/g, '<br>')
  return s
}

function decodeHtml (str) {
  let s = ''
  if (str.length === 0) return str
  s = str.replace(/>/g, '&')
  s = s.replace(/</g, '<')
  s = s.replace(/>/g, '>')
  s = s.replace(/ /g, ' ')
  s = s.replace(/'/g, "'")
  s = s.replace(/"/g, '"')
  s = s.replace(/<br>/g, '\n')
  return s
}

/**
 * @desc 获取以"&"字符分隔的参数或hash字段的值
 * @param {String} param 参数名
 * @param {Boolean} isTop  是否为顶级window的url，默认false
 */
export function getUrlParams (param: string, isTop = false) {
  let url: string = location.search
  let str = '?'
  if (isTop) {
    url = (top as any).location.search
  }
  const obj = {}
  let value = ''
  if (url.indexOf(str) !== -1) {
    str = url.slice(1)
    const strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      obj[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1])
    }
    for (const j in obj) {
      if (j == param) {
        value = obj[j] !== 'undefined' ? obj[j] : ''
      }
    }
  }
  return encodeHtml(value)
}

export const html = {
  encode: encodeHtml,
  decode: decodeHtml
}

export const url = {
  get: getUrlParams
}

function createScript (url: string) {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = urlAddVersion(url)
  return script
}

function createLink (url: string) {
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.type = 'text/css'
  link.href = urlAddVersion(url)
  return link
}

export function includeScript (url: string) {
  const script = createScript(url)
  document.getElementsByTagName('body')[0].appendChild(script)
}

/**
 * 异步导入js文件
 * @param url
 * @returns {Promise<unknown>}
 */
export function includeScriptAsync (url: string) {
  return new Promise((resolve, reject) => {
    const script = createScript(url)
    document.getElementsByTagName('body')[0].appendChild(script)
    script.onload = () => {
      resolve(url)
    }
    script.onerror = () => {
      reject(url)
    }
  })
}

/**
 * 按顺序依次导入js文件，某个js加载失败，不影响后续js的加载
 * @param list
 * @returns 异步函数默认返回promise
 */
export async function includeScriptListOrdinal (list: string[]) {
  for (let url of list) {
    try {
      await includeScriptAsync(url)
    } catch (e) {}
  }
}

/**
 * 批量引入js，支持异步处理
 * @param list
 * @param async 是否需要异步处理
 */
export function includeScriptList (list: string[], async = false) {
  if (async) {
    return Promise.all(list.map((url: string) => includeScriptAsync(url)))
  }
  list.forEach((url: string) => includeScript(url))
  return new Promise((resolve) => () => {
    resolve(null)
  })
}

/**
 * 导入css文件
 * 所有的导入css文件都应该在主题的前面，主题会进行颜色覆盖
 * @param url
 */
export function includeLinkStyle (url: string, position = 'head') {
  const link = createLink(url)
  if (window.$('link#skins').length > 0) {
    window.$('link#skins').before(link)
  } else {
    window.$('link:last').before(link)
  }
}

export function includeLinkList (list: string[]) {
  list.forEach((url: string) => includeLinkStyle(url))
}

export function setLocalStorage (key: string, value: any) {
  if (value) {
    if (typeof value === 'object') {
      localStorage.setItem(key, JSON.stringify(value))
    } else {
      localStorage.setItem(key, value)
    }
  } else {
    localStorage.setItem(key, '')
  }
}

export function getLocalStorage (key: string) {
  const value = localStorage.getItem(key)
  if (value) {
    try {
      return JSON.parse(value)
    } catch {
      return value
    }
  }
  return value
}

/**
 * 设置sessionStorage
 * @param key
 * @param value
 */
export function setSessionStorage (key: string, value: any) {
  if (value) {
    if (typeof value === 'object') {
      sessionStorage.setItem(key, JSON.stringify(value))
    } else {
      sessionStorage.setItem(key, value)
    }
  } else {
    sessionStorage.setItem(key, '')
  }
}

/**
 * 获取sessionStorage
 * @param key
 */
export function getSessionStorage (key: string) {
  const value = sessionStorage.getItem(key)
  if (value) {
    try {
      return JSON.parse(value)
    } catch {
      return value
    }
  }
  return value
}

/**
 * 删除session
 * @param key
 */
export function removeSessionStorage (key: string) {
  sessionStorage.removeItem(key)
}

export function getCookie (key: string) {
  return cookieJs.get(COOKIE_PREFIX + key)
}

export function setCookie (key, value) {
  cookieJs.set(key, value)
  cookieJs.set(COOKIE_PREFIX + key, value)
}

export function firstLowerCase (str: string) {
  return str.replace(/^\S/, (s) => {
    return s.toLowerCase()
  })
}

export function firstUpperCase (str: string) {
  return str.replace(/^\S/, (s) => {
    return s.toUpperCase()
  })
}

// 静态文件服务器地址
export function getlqAssetsBaseUrl () {
  return env.lqAssetsServeUrl
}

export function getBaseUrl () {
  return process.env.BASE_URL
}
export function getApiHost () {
  return env.baseUrl
}

export function getHost () {
  const _origin = parent.location.origin
  if (_origin.indexOf('localhost') > -1) {
    return env.lqBaseUrl
  }
  return _origin
}

/**
 * 获取用户的信息，格式化参数
 * @param userInfo
 */
export function getUserInfo (userInfo: any) {
  if (userInfo) {
    const token = userInfo.token || userInfo.Token
    return {
      token,
      tmsCode: userInfo.tmsCode || userInfo.TMSCode,
      userId: userInfo.UserId,
      userName: userInfo.UserName || '',
      loginSite: userInfo.LoginSite,
      tmsbshxsite: userInfo.hxsite || userInfo.tmsbshxsite || window.$.cookie('tmsbshxsite') || '',
      browserId: null
    }
  }
  return {}
}

/**
 * 通过java接口，获取ViewBag数据
 * @param url(string)
 * @param data(object)，默认值{}
 * @param isToString(boolean)，默认值false
 * @param async(boolean)，默认值false
 * @returns async ? new func() : result
 */
export function getDataViewByJava (
  url: string,
  data = {},
  isToString = false,
  async = false
) {
  let result = {}
  let callback = function (val:object) { };
  let func = function () { };
  func.prototype.then = function (cb) {
      callback = cb || function () { };
  };
  window.$.javaAjax({
    url: urlFirstToLowerCase(url),
    async: Boolean(async),
    data,
    isNotCompare: true,
    success (res) {
      if (!res.success || !res.data) return
      result = res.data
      if (isToString && typeof result === 'object') {
        for (let key of Object.keys(result)) {
          const value = result[key]
          if (
            Object.is(value, undefined) ||
            Object.is(value, null) ||
            Object.is(value, NaN)
          ) {
            result[key] = ''
          } else if (typeof result[key] !== 'string') {
            result[key] = JSON.stringify(value)
          }
        }
      }
    },
    complete: function () {
        callback(result)
    }
  })
  return async ? new func() : result
}



/**
 * 匹配白名单加lq-saas-web前缀
 * @param url(string)
 */
export function getEVNUrlByWhitelist (url) {
  if(typeof (window as any).getEVNUrlByWhitelist === "function") {
    return (window as any).getEVNUrlByWhitelist(url)
  } else {
    return url
  }
}

/**
 * url首字母转小写
 * @param url
 */
export function urlFirstToLowerCase (url: string) {
  if (typeof url !== 'string') return url
  return url
    .split('/')
    .map((str) => firstLowerCase(str))
    .join('/')
}


/**
 * 获取Starttime和Endtime
 * @param morendays(string|number)
 * @returns { Starttime, Endtime }
 */
export function getStartAndEndStartTime (morendays: string | number): object {
  if (typeof morendays === 'undefined') {
    morendays = window.$.getcookie('morendays')
    morendays = morendays == '' || morendays == '0' ? -2 : -Number(morendays) + 1
  }
  let StartDate = new Date(Date.now() + Number(morendays) * 24 * 60 * 60 * 1000)
  let EntDate = new Date()
  let Starttime = (StartDate as any).Format('yyyy-MM-dd') + ' 00:00:00'
  let Endtime = (EntDate as any).Format('yyyy-MM-dd') + ' 23:59:59'
  return { Starttime, Endtime }
}


export const isFrame =
  (self.frameElement && self.frameElement.tagName.toLowerCase() == 'iframe') ||
  window.frames.length != parent.frames.length ||
  self != top
